export class VoerkaI18nError extends Error{}
export class VoerkaI18nInvalidLanguageError extends VoerkaI18nError{}
export class VoerkaI18nOnlyOneAppScopeError extends VoerkaI18nError{}
export class VoerkaI18nChangeLanguageError extends VoerkaI18nError{}
export class VoerkaI18nLoadLanguageError extends VoerkaI18nError{}
